import { render, staticRenderFns } from "./c_user_options.vue?vue&type=template&id=3671fb17&scoped=true"
import script from "./c_user_options.vue?vue&type=script&lang=js"
export * from "./c_user_options.vue?vue&type=script&lang=js"
import style0 from "./c_user_options.vue?vue&type=style&index=0&id=3671fb17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671fb17",
  null
  
)

export default component.exports